import React from "react";

import { useIntl } from "react-intl";

import noAccessImage from "@app/assets/activity/annotation/no-access.svg";

import styles from "./NoAccess.module.scss";

const NoAccess = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <img alt="No access icon" className={styles.image} src={noAccessImage} />
      <div className={styles.title}>
        {intl.formatMessage({
          id: "component.activityAnnotation.notFound.title",
          defaultMessage: "Activity not found",
          description: "Title for the NotFound state of activity annotation",
        })}
      </div>
      <div className={styles.description}>
        {intl.formatMessage({
          id: "component.activityAnnotation.notFound.description",
          defaultMessage: "You don’t have access to this activity or it may have been deleted",
          description: "Description for the NotFound state of activity annotation",
        })}
      </div>
    </div>
  );
};

export default NoAccess;
